import { render } from "./DropzonePassport.vue?vue&type=template&id=1f76a80f"
import script from "./DropzonePassport.vue?vue&type=script&lang=js"
export * from "./DropzonePassport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__